import {
  ButtonType,
  CaesarsButton,
  Selectors,
  useIsDesktop,
  useIsWeb,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {useDispatch, useSelector} from 'Provider';
import envData from 'env.json';
import {DateTime} from 'luxon';
import {View} from 'native-base';
import React from 'react';
import {Linking} from 'react-native';

import {PDBOffer} from 'models/Offer';
import {isWebViewSelector} from 'store/content';

import {OffersActions} from '../../../store/offers/offers.reducer';
import OfferDetailsButtonSpacing from './OfferDetailsButtonSpacing';
import OfferDetailsButtonsWrapper from './OfferDetailsButtonsWrapper';

const {API_URL, USE_STORYBOOK} = envData;
interface PDBButtonsPropTypes {
  offer: PDBOffer;
  closeSlideFlyout: () => void;
  selectedPropertyID: string;
  setBookingUrl: (url: string) => void;
}

const PDBButtons: React.FC<PDBButtonsPropTypes> = ({
  offer,
  closeSlideFlyout,
  selectedPropertyID,
  setBookingUrl,
}) => {
  const dispatch = useDispatch();
  const isWebView = useSelector(isWebViewSelector);
  const isDesktop = useIsDesktop();

  const today = Date.now();
  const bookingStartDate =
    DateTime.fromISO(offer.start).valueOf() < today
      ? DateTime.local().plus({days: 1}).toFormat('MM/dd/yyyy')
      : DateTime.fromISO(offer.start).toFormat('MM/dd/yyyy');
  const bookingEndDate = DateTime.fromFormat(bookingStartDate, 'MM/dd/yyyy')
    .plus({days: 2})
    .toFormat('MM/dd/yyyy');
  const patronToken = useWidgetState(Selectors.patrontokenSelector);

  const url = `${API_URL}/book?view=ratecal&offerCode=${offer.id}&arrivalDate=${bookingStartDate}&departureDate=${bookingEndDate}&propCode=${selectedPropertyID}&adults=1&children=0&login=yes`;
  const bookUrl = isWebView
    ? `${API_URL}/asp_net/mobileredirect.aspx?type=redirect&otoken=[0]&redirectUrl=${encodeURIComponent(
        url
      )}`
    : url;

  const nativeBookUrl = `${API_URL}/asp_net/mobileredirect.aspx?type=redirect&otoken=${patronToken}&redirectUrl=${encodeURIComponent(
    url
  )}`;

  const isWeb = useIsWeb();

  return (
    <OfferDetailsButtonsWrapper>
      <View flexDirection={isDesktop ? 'row' : 'column-reverse'}>
        <CaesarsButton
          type={ButtonType.TEXT_CTA}
          title="Close"
          onPress={closeSlideFlyout}
          isFullWidth={!isDesktop}
        />

        {offer.status.toLowerCase() === 'bookable' && (
          <>
            <OfferDetailsButtonSpacing />
            <CaesarsButton
              title="Book Now"
              onPress={() => {
                dispatch(OffersActions.bookOfferCalendar(selectedPropertyID));
                isWeb ? Linking.openURL(bookUrl) : setBookingUrl(nativeBookUrl);
              }}
              isFullWidth={!isDesktop}
            />
          </>
        )}
      </View>
    </OfferDetailsButtonsWrapper>
  );
};
export default PDBButtons;
